<template>
  <div class="phone-bank-page">
    <div class="search-container">
      <div class="marquee-container">
        <div class="marquee-wrapper">
          <div class="marquee-content">
            <div class="marquee-text">{{ marqueeText }}</div>
            <div class="marquee-text">{{ marqueeText }}</div>
          </div>
        </div>
      </div>
      <van-icon name="filter-o" @click="showFilter = true" />
    </div>

    <div class="page-content" @scroll="handleScroll">
    <a-card style="width: 100%" size="small" v-for="item in phoneBankList" :key="item.phoneBankId"
      :title="item.customerName" @click="goRecord(item)" class="mt-10">
      <div style="display: flex;">
        <Cell label="区域" :value="item.area" />
        <Cell label="校区" :value="item.systemSchoolName" />
      </div>
      <div style="display: flex;">
        <Cell label="年级">
          {{ selectDictLabel(gradeList, item.grade) }}
        </Cell>
        <Cell label="状态">
          {{ selectDictLabel(statusList, item.status) }}
        </Cell>
      </div>
      <div style="display: flex;" v-if="item.lastFollowUser || item.callStatus">
        <Cell label="最后跟进人" :value="item.lastFollowUser" />
        <Cell label="通话状态">
          {{ selectDictLabel(callStatusList, item.callStatus) }}
        </Cell>
      </div>
      <Cell v-if="item.lastFollowTime" label="最后更近时间" :value="item.lastFollowTime" />
      <Cell v-if="item.schoolName" label="曾就读学校" :value="item.schoolName" />
      <Cell v-if="item.remark" label="备注" :value="item.remark" />
      <Cell v-if="item.lastFollowRemark" label="最后跟进内容" :value="item.lastFollowRemark" />
      <div class="page-content-footer">
        <a-button type="primary" style="width: 45%;margin-left: 3%;" @click.stop="goTell(item)">拨号</a-button>
        <a-button type="primary" style="width: 45%;margin-left: 3%;" @click.stop="goTransfer(item)">结转</a-button>
      </div>
    </a-card>
    <div v-if="loading" class="loading">正在加载...</div>
    <div v-if="!hasMore && !loading" class="no-more">没有更多数据了</div>
    </div>

    <Teleport to="body">
      <div v-if="showFilter" class="filter-mask" @click="closeFilter">
        <div class="filter-drawer" @click.stop>
          <div class="filter-header">
            <h3>筛选</h3>
            <van-icon name="cross" @click="closeFilter" />
          </div>

          <div class="filter-sections">
            <div class="filter-section">
              <div class="filter-title">来源</div>
              <div class="filter-options">
                <div v-for="item in sourceList" :key="item.dictValue" class="filter-option"
                  :class="{ active: filterData.source === item.dictValue }" @click="selectSource(item.dictValue)">
                  {{ item.dictLabel }}
                </div>
              </div>
            </div>

            <div class="filter-section">
              <div class="filter-title">年级</div>
              <div class="filter-options">
                <div v-for="item in gradeList" :key="item.dictValue" class="filter-option"
                  :class="{ active: filterData.grade === item.dictValue }" @click="selectGrade(item.dictValue)">
                  {{ item.dictLabel }}
                </div>
              </div>
            </div>

            <div class="filter-section">
              <div class="filter-title">通话状态</div>
              <div class="filter-options">
                <div v-for="item in callStatusList" :key="item.dictValue" class="filter-option"
                  :class="{ active: filterData.callStatus === item.dictValue }" @click="selectCallStatus(item.dictValue)">
                  {{ item.dictLabel }}
                </div>
              </div>
            </div>

            <div class="filter-section">
              <div class="filter-title">状态</div>
              <div class="filter-options">
                <div v-for="item in statusList" :key="item.dictValue" class="filter-option"
                  :class="{ active: filterData.status === item.dictValue }" @click="selectStatus(item.dictValue)">
                  {{ item.dictLabel }}
                </div>
              </div>
            </div>
          </div>

          <div class="filter-footer">
            <button class="reset-btn" @click="resetFilter">重置</button>
            <button class="confirm-btn" @click="confirmFilter">确定</button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<style scoped>
.phone-bank-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;
}

.marquee-container {
  width: 100%;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 8px 0;
  height: 36px;
  display: flex;
  align-items: center;
}

.marquee-wrapper {
  display: flex;
  align-items: center;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}

.marquee-content {
  display: flex;
  align-items: center;
  animation: marquee 20s linear infinite;
  /* 确保动画流畅运行 */
  will-change: transform;
}

.marquee-text {
  white-space: nowrap;
  font-size: 14px;
  color: #333;
  margin-right: 100px;
  /* 文本之间的间隔 */
}

/* 定义滚动动画 */
@keyframes marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
    /* 滚动到第一个文本刚好离开视图 */
  }
}
</style>

<script setup>
import { computed, onActivated, onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import { getPhoneBankList, getPhoneBankDetail, getUserAllocationInfoForPhone, transferred } from '@/api/phoneBank'
import Cell from '@/component/cell.vue'
import { debounce } from '@/utils/common'
import { showConfirmDialog } from 'vant'
import { useDict } from '@/utils/dict'
import { selectDictLabel } from '@/utils/dict'

const router = useRouter()
const {
  grade_list: gradeList,
  phone_bank_status: statusList,
  call_status: callStatusList,
  phone_bank_source: sourceList
} = useDict(
  'grade_list',
  'phone_bank_status',
  'call_status',
  'phone_bank_source'
)

const uerAllocationInfo = ref({})
const showFilter = ref(false)
const pageNum = ref(1)
const pageSize = ref(10)
const phoneBankList = ref([])
const phone = ref()
const loading = ref(false)
const hasMore = ref(true)
const scrollTimeout = ref(null)
const filterData = reactive({
  callStatus: null,
  status: '2',
  source: null,
  grade: null
})

const marqueeText = computed(() => {
  const info = uerAllocationInfo.value || {}
  if (info.totalCount !== null && info.totalCount !== undefined) {
    return `已下发数：${info.showCount || 0}, 已拨打数：${info.callCount || 0}, 未拨打数：${info.showCount - info.callCount || 0}, 结转数：${info.transferredCount || 0}`
  }
  return `号码库总数：${info.showCount || 0}, 已拨打数：${info.callCount || 0}, 未拨打数：${info.showCount - info.callCount || 0}, 结转数：${info.transferredCount || 0}`
})

onMounted(() => {
  initData()
})

onActivated(() => {
  resetList()
  loadPhoneBankList()
  loadAllocationInfo()
})

function initData() {
  resetList()
  showFilter.value = false
  loadPhoneBankList()
  loadAllocationInfo()
}

function resetList() {
  pageNum.value = 1
  hasMore.value = true
  phoneBankList.value = []
}

function loadAllocationInfo() {
  getUserAllocationInfoForPhone().then(response => {
    uerAllocationInfo.value = response
  })
}

const onSearch = debounce(() => {
  resetList()
  loadPhoneBankList()
}, 300)

function loadPhoneBankList() {
  if (loading.value || !hasMore.value) return
  loading.value = true
  const params = {
    pageNum: pageNum.value,
    pageSize: pageSize.value,
    phone: phone.value,
    callStatus: filterData.callStatus,
    status: filterData.status,
    source: filterData.source,
    grade: filterData.grade
  }
  getPhoneBankList(params).then(response => {
    if (response && Array.isArray(response)) {
      phoneBankList.value = pageNum.value === 1 ? response : [...phoneBankList.value, ...response]
      if (response.length < pageSize.value) {
        hasMore.value = false
      }
    } else {
      hasMore.value = false
    }
    pageNum.value++
    loading.value = false
  }).catch(() => {
    loading.value = false
  })
}

function handleScroll(event) {
  if (scrollTimeout.value) {
    clearTimeout(scrollTimeout.value)
  }
  scrollTimeout.value = setTimeout(() => {
    const { scrollTop, scrollHeight, clientHeight } = event.target
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      loadPhoneBankList()
    }
  }, 100)
}

function goRecord(item) {
  router.push({
    path: '/phoneBankRecord',
    query: {
      phoneBankId: item.phoneBankId
    }
  })
}

function closeFilter() {
  showFilter.value = false
}

function selectSource(value) {
  filterData.source = filterData.source === value ? null : value
}

function selectCallStatus(value) {
  filterData.callStatus = filterData.callStatus === value ? null : value
}

function selectStatus(value) {
  filterData.status = filterData.status === value ? null : value
}

function selectGrade(value) {
  filterData.grade = filterData.grade === value ? null : value
}

function goTransfer(item) {
  showConfirmDialog({
    message: '确定要将号码库转移至公海吗？'
  }).then(() => {
    transferred(item.phoneBankId).then(() => {
      message.success('操作成功')
      resetList()
      loadPhoneBankList()
    }).catch(() => {
    })
  }).catch(() => {
  })
}

function goTell(item) {
  getPhoneBankDetail(item.phoneBankId).then(response => {
    if (!response) return
    if (response.phone && response.otherPhone) {
      showConfirmDialog({
        title: '选择电话号码',
        message: `请选择要拨打的电话号码：\n1. ${response.phone}\n2. ${response.otherPhone}`,
        confirmButtonText: '拨打号码1',
        cancelButtonText: '拨打号码2',
        closeOnClickOverlay: true
      }).then(() => {
        window.location.href = `tel:${response.phone}`
      }).catch(() => {
        window.location.href = `tel:${response.otherPhone}`
      })
      return
    }
    if (response.phone) {
      window.location.href = `tel:${response.phone}`
      return
    }
    if (response.otherPhone) {
      window.location.href = `tel:${response.otherPhone}`
      return
    }
    alert('未找到电话号码')
  })
}

function resetFilter() {
  filterData.callStatus = null
  filterData.status = '2'
  filterData.source = null
  filterData.grade = null
}

function confirmFilter() {
  resetList()
  loadPhoneBankList()
  closeFilter()
}
</script>

<style scoped>
.search-container {
  flex-shrink: 0;
  background-color: #f8f8f8;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  gap: 12px;
}

.search-container .van-icon {
  font-size: 20px;
  color: #666;
  flex-shrink: 0;
}

.search-container .search-input {
  flex: 1;
  margin-right: 10px;
}

.page-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 16px 16px;
  background-color: #f8f8f8;
}

.page-content::-webkit-scrollbar {
  display: none;
}

.loading,
.no-more {
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #999;
}

.no-more {
  color: #ccc;
}

.flex-box {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    flex: 1;
  }
}

.mt-10 {
  margin-top: 10px;
}

.page-content-footer {
  padding: 10px;
}

.search-input {
  padding: 10px;
}

.filter-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.filter-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

/* 筛选弹窗样式 */

.filter-sections {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.filter-section {
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.filter-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}

.filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-option {
  padding: 6px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-option.active {
  border-color: #1890ff;
  color: #1890ff;
  background-color: #e6f7ff;
}

.filter-footer {
  flex-shrink: 0;
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  display: flex;
  gap: 12px;
  border-top: 1px solid #f0f0f0;
  background-color: #fff;
}

.reset-btn,
.confirm-btn {
  flex: 1;
  padding: 8px 0;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.reset-btn {
  background-color: #f5f5f5;
  color: #666;
}

.confirm-btn {
  background-color: #1890ff;
  color: white;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}
</style>

<style>
.filter-mask {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000 !important;
  display: flex;
  justify-content: flex-end;
}

.filter-drawer {
  width: 80%;
  max-width: 300px;
  height: 100% !important;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideInRight 0.3s;
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: border-box;
}
</style>
